module.exports = __webpack_public_path__ + "static/media/iframe.1c1e7c78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/elements/iframe.svg
// module id = 985
// module chunks = 1